import { Button, Card, Form, Input } from "antd";
import sajana from "./../../../assets/images/profile/sajana-profile.png";
import msgImg from "./../../../assets/images/icons/thakyou-icon.png";
import { useState } from "react";
import { submitFeedbackApi } from "../../../services/feedback.service";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";

const { TextArea } = Input;

const QueryForm = ({ userName }: { userName: string }) => {
  const [submitted, setSubmitted] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
const name = (userData?.name || "").split(" ")[0];
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const state = useAppSelector((state) => state);

  const { user_id, survey_id } = state.feedback;

  return (
    <section className="query-form">
      <Card>
        {!submitted && <h3 className="title">Welcome {name}! <br /> to the caring world of skincare</h3>}
        {submitted && <h3 className="title">Thank you {name}!</h3>}
        <div className="bg">
          {!submitted &&
            <div className="top-header-title">
              <h2 className="query-form__subtile">I’m excited to build your personal skincare space. Do you have any request for me before I start building your routine?</h2>
              <img src={sajana} alt="sajana" />
            </div>
          }
          {!submitted ? (
            <Form
              form={form}
              onFinish={(values) => {
                const data = {
                  user_id: user_id,
                  survey_id: survey_id,
                  feedback: [
                    {
                      "How satisfied are you with your personalized space?":
                        values.request,
                    },
                  ],
                };
                dispatch(
                  submitFeedbackApi({
                    data,
                    finalCallback: () => {
                      setLoading(false);
                      form.resetFields();
                    },
                    successCallback: () => {
                      setSubmitted(true);
                    },
                    failureCallback: () => {
                      setError(true);
                    },
                  })
                );
              }}
            >
              <Form.Item
                name="request"
                rules={[
                  { required: true, message: "Please provide your feedback." },
                ]}
              >
                <TextArea
                  rows={4}
                  placeholder="For example you can say: Recommend different products than automated suggestion or don’t suggest any products from this brand...etc. Use this section to request anything before I start refining your skincare routine."
                  maxLength={600} // Set to a more realistic limit
                />
              </Form.Item>

              <div className="submit-btn-holder">
                <Button
                  htmlType="submit"
                  className="submit-btn"
                  loading={loading}
                >
                  Submit
                </Button>
              </div>
            </Form>
          ) : (
            <div className="thankyou-response">
              <div className="top-header-title ">
                <h2 className="query-form__subtile">Your request is submitted. You’ll receive your entire skincare space via email in two business days or less!</h2>
                <img src={sajana} alt="sajana" />
              </div>
              {/* <p>
                Your request is submitted. You'll receive your refined routine
                via email in 2 business days or less!
              </p> */}
              <div className="thankyou-response-msg">
                <div className="heading">
                  <img className="image" src={msgImg} alt="img" width={40} />
                  <h2 className="title">Missing Skincare Promise</h2>
                </div>
                <div className="msg-body">
                  <div className="msg">The entire space is made with honest care for your skin and budget — no product pushes, no affiliates, no sponsors.</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Card>
    </section>
  );
};
export default QueryForm;
